<i18n src="@/locales/components/CbsDynamicFormConfig.json"></i18n>

<template>
	<div class="number-field-config">
		<vs-row class="pt-2">
			<vs-col vs-w="4" vs-xs="12">
				<vs-radio vs-name="type" :vs-value="$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.NUMBER.TYPE_NONE" v-model="localFormatValue">{{ $t("FieldConfig.NumberNoneFormat") }}</vs-radio>
			</vs-col>
			<vs-col vs-w="4" vs-xs="12">
				<vs-radio vs-name="type" :vs-value="$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.NUMBER.TYPE_MONEY" v-model="localFormatValue">{{ $t("FieldConfig.NumberMoneyFormat") }}</vs-radio>
			</vs-col>
			<vs-col vs-w="4" vs-xs="12">
				<vs-radio vs-name="type" :vs-value="$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.NUMBER.TYPE_NUMERIC" v-model="localFormatValue">{{ $t("FieldConfig.NumberNumericFormat") }}</vs-radio>
			</vs-col>
		</vs-row>

		<div class="my-5">
			<legend>{{ $t("FieldConfig.Unit") }}:</legend>
			<cbs-input class="inputx w-full" v-model="localUnitValue" :placeholder="`${$t('Actions.Input')} ${$t('FieldConfig.Unit').toLowerCase()}`" />
		</div>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	name: "NumberFieldConfig",
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => prop.hasOwnProperty("format") && prop.hasOwnProperty("unit")
		}
	},
	computed: {
		localFormatValue: {
			get() {
				return this.value.format;
			},
			set(val) {
				this.$emit("input", { ...this.value, format: val });
			}
		},
		localUnitValue: {
			get() {
				return this.value.unit;
			},
			set(val) {
				this.$emit("input", { ...this.value, unit: val });
			}
		}
	}
};
</script>
